import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";

export default function UpgradeRequiredPage({
  title = "Upgrade required",
  description = "Your current subscription does not include access to this feature. Upgrade your plan to continue.",
}) {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-[70vh] px-16 py-24 d-flex flex-center flex-justify-center">
      <div className="mx-auto w-full max-w-3xl rounded-lg border border-slate-200 bg-white p-24 shadow-sm dark:border-slate-700 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
        <div className="d-flex flex-center mb-16" style={{ gap: 10 }}>
          <span className="inline-flex items-center justify-center rounded-full p-10 bg-emerald-100 dark:bg-emerald-900/30">
            <Lock className="h-5 w-5 text-emerald-700 dark:text-emerald-300" />
          </span>
          <h2 className="text-xl font-semibold text-slate-900 dark:text-white m-0">
            {title}
          </h2>
        </div>

        <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-16 text-center">
          {description}
        </p>

        <div className="flex items-center justify-center">
          <button
            type="button"
            onClick={() => navigate("/account/upgrade")}
            className="group inline-flex items-center justify-center gap-2 rounded-md border-0 bg-[#16A34A] px-5 py-2.5 text-sm font-semibold text-white cursor-pointer transition-all duration-200 hover:bg-[#15803D] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-[#1A1F2C]"
          >
            Upgrade Plan
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </div>
  );
}

